import JsBarcode from 'jsbarcode';

/** Same constant as packing-label-service/barcodes.js */
const PIXELS_PER_MM = 3.779528;

const EAN13_DEFAULTS = {
  format: 'EAN13',
  displayValue: true,
  font: 'Helvetica',
  fontSize: 32,
  width: 0.5 * PIXELS_PER_MM,
  height: 38.845 * PIXELS_PER_MM,
  marginLeft: 0,
  marginRight: 4.78 * PIXELS_PER_MM,
  textMargin: -4,
};

export function renderEAN13(svgElement, barcodeValue, config = {}) {
  if (!svgElement || !barcodeValue) return false;
  try {
    JsBarcode(svgElement, barcodeValue, {
      ...EAN13_DEFAULTS,
      ...config,
    });
    return true;
  } catch {
    return false;
  }
}

/** Narrow EAN for the keg right rail. Matches packing-label-service generateKegEan13. */
export function renderKegRightEan13(svgElement, barcodeValue) {
  return renderEAN13(svgElement, barcodeValue, {
    width: 1.05,
    height: 62,
    fontSize: 10,
    textMargin: 0,
    margin: 0,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 4,
    marginRight: 4,
  });
}

export function renderPalletPrimaryBarcode(svgElement, barcodeValue) {
  return renderEAN13(svgElement, barcodeValue, {
    marginLeft: 0,
    marginRight: 50,
    width: 4,
    height: 200,
  });
}

export function renderCODE128(svgElement, barcodeValue) {
  if (!svgElement || !barcodeValue) return false;
  try {
    JsBarcode(svgElement, barcodeValue, {
      format: 'CODE128',
      displayValue: false,
      font: 'Helvetica',
    });
    return true;
  } catch {
    return false;
  }
}
